const homePageConstantsEn = {
  homePageWelcomeMessage: "Welcome, {{name}}! Please select what you'd like to manage from the control panel.",
};

export default homePageConstantsEn;
